import React from "react";
import { HelpCircle, CheckCircle } from "lucide-react";

interface FeaturedSnippetProps {
  question: string;
  answer: string;
  additionalInfo?: string[];
  className?: string;
}

const FeaturedSnippet: React.FC<FeaturedSnippetProps> = ({ 
  question, 
  answer, 
  additionalInfo,
  className = "" 
}) => {
  return (
    <div className={`bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8 ${className}`}>
      <div className="flex items-start">
        <HelpCircle className="h-6 w-6 text-blue-600 mr-3 mt-1 flex-shrink-0" />
        <div className="flex-1">
          <h3 className="font-bold text-lg text-blue-900 mb-3">{question}</h3>
          <p className="text-blue-800 mb-4 text-base leading-relaxed">{answer}</p>
          
          {additionalInfo && additionalInfo.length > 0 && (
            <div className="space-y-2">
              {additionalInfo.map((info, index) => (
                <div key={index} className="flex items-start">
                  <CheckCircle className="h-4 w-4 text-blue-600 mr-2 mt-0.5 flex-shrink-0" />
                  <span className="text-sm text-blue-700">{info}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeaturedSnippet;